module.exports = __webpack_public_path__ + "img/file-earmark-image-fill.0cb00bdd.svg";